import {createStore} from 'vuex'
import router from "@/router";
import {getActiveLanguages, getProfile, login, postFCMToken} from "@/API/API";
// import fcmToken from "@/utils/fcm";
import httpClient from "@/API/HttpClient";
import fcmToken from "@/utils/fcm";

export default createStore({
    state: {
        token: localStorage.getItem('token') || '',
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {role: ''},
        roomId: '',
        fcmMessage: {},
        languages: []
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', state.token)
        },
        SET_USER(state, user) {
            state.user = user
            localStorage.setItem('user', JSON.stringify(state.user))
        },
        LOGOUT(state) {
            state.token = ''
            state.user = {role: ''}
            localStorage.removeItem('token')
            localStorage.removeItem('user')
        },
        ADD_FCM_MESSAGE(state, fcmMessage) {
            state.fcmMessage = fcmMessage
        },
        SET_LANGUAGES(state, languages) {
            state.languages = languages
        }
    },
    actions: {
        login({commit}, {phone, password}) {
            return new Promise((resolve, reject) => {
                login(phone, password)
                    .then(resp => {
                        httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.token
                        commit('SET_TOKEN', resp.data.token)
                        fcmToken().then(token => postFCMToken(token))
                        getProfile().then(resp => {
                            commit('SET_USER', resp.data)
                            resolve(resp.data)
                        })
                            .catch(err => reject(err.response.data))
                    }).catch((err) => {
                    reject(err.response.data)
                })
            })
        },
        setUser({commit}, user) {
            commit('SET_USER', user)
        },
        logout({commit}) {
            commit('LOGOUT')
            router.push('/login')
        },
        addFcmMessage({commit}, fcmMessage) {
            commit('ADD_FCM_MESSAGE', fcmMessage)
        },
        async getLanguages({commit}) {
            commit('SET_LANGUAGES', (await getActiveLanguages()).data)
        }
    },
    modules: {},
    getters: {
        token: state => 'Bearer ' + state.token,
        isLoggedIn: state => state.token !== '',
    }
})
